let schedule = [],
    timer = null;

export default function scheduleCommit(func, args, eventDone) {
    schedule.push({ func, args: args });
    timer && clearTimeout(timer);
    timer = setTimeout(() => {
        console.log("%c flushScheduleCommit", "color:green");
        schedule.forEach((i) => {
            let funcName = i.func,
                args = i.args;
            if (!args) args = ["_act$"];
            else args.push("_act$");
            _view["UI"][funcName](...args);
        });
        eventDone();
        schedule = [];
        timer = null;
    }, 150);
}
